export const routes = [
  {
    path: '/sala-principal/:id/sala-indicadores-nivel',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'sala.indicadores.nivel.list',
    meta: {
      requiresAuth: true
    }
  }
]
